<h1 class="Anton">Galeria</h1>
<div class="contacto">
    hola
</div>